(function () {
    const sidebarSections = {
        isMobile: false,
        $scrollPoints: $('.to-section[id]:visible'),
        $block: $('.sections-block'),
        vPort: 'screen-sm',
        prevScrollpos: window.pageYOffset,
        scrollingToTarget: false,

        init: function () {
            if (sidebarSections.$scrollPoints.length) {
                sidebarSections.initSections();
                sidebarSections.set.selectedSection();
                sidebarSections.controller();
            } else {
                //if there is no section then hide action bar on tablet
                // hiding with visibility and height to keep the layout in order
                $('.sections-navigation').hide();
            }
        },

        initSections: function () {
            //if theres is sections then show section word & initialize it
            $('.sections-block-container').removeClass('not-visible');
            $('.article-navigation-items-separator').removeClass('not-visible');

            $.each(sidebarSections.$scrollPoints, (index, item) => {
                if ($(item).hasClass('section2') && $(item).closest('.block-box').length) return;
                sidebarSections.$block.append(sidebarSections.get.htmlSection($(item)));
            });

            $('.actionsbar__has__sections .sections-block-container').css({
                'max-height': 'calc(100vh - " +$("header").height()+ "px)',
            });
        },

        controller: function () {
            var _window = null,
                scrollingPoints = null,
                fixedElems = null,
                currentId = null,
                preceding = null;

            $(document).on('click', '.sections-block a', function (e) {
                e.preventDefault();
                UX.sidebarSections.scroll($(this), this.hash);
                sidebarSections.$block.find('a').removeClass('active');
                $(this).addClass('active');
            });

            _window = $(window);
            $(window).on('scroll', function (e) {
                if (!sidebarSections.scrollingToTarget) {
                    (scrollingPoints = UX.sidebarSections.$scrollPoints),
                        (fixedElems = sidebarSections.get.fixedpageElementsHeight()),
                        // bottom = _window.scrollTop() + _window.height(),
                        (top = _window.scrollTop() + fixedElems);
                    currentId;
                    {
                        // taking the previous title in case we are scrolling but there is nothing what is valid to be marked as current
                        preceding;
                        scrollingPoints.each(function (i, o) {
                            // picking the last closest preceding element
                            var item = $(o);
                            if (item.offset().top < top && (!preceding || preceding.offset().top < item.offset().top)) {
                                preceding = item;
                            }
                        });
                        if (preceding) {
                            currentId = preceding.attr('id');
                        }
                    }

                    if (currentId) {
                        UX.sidebarSections.$block
                            .find('a')
                            .removeClass('active')
                            .filter('[href="#' + currentId + '"]')
                            .addClass('active');
                    } else {
                        UX.sidebarSections.$block.find('a').removeClass('active');
                    }
                }

                if (sidebarSections.check.reachFooterEdge()) {
                    $('.actionsbar__has__sections').css({top: 'unset', bottom: $('footer').height()});
                } else {
                    $('.actionsbar__has__sections').css({top: '', bottom: ''});
                }

                sidebarSections.prevScrollpos = window.pageYOffset;
            });
        },

        scroll: function ($this, hash) {
            var target = hash,
                $target = $(target),
                currentScrollPos = $target.offset().top,
                position = currentScrollPos - sidebarSections.get.fixedpageElementsHeight(currentScrollPos);

            sidebarSections.scrollingToTarget = true;

            $('html, body')
                .stop()
                .animate(
                    {
                        scrollTop: position,
                    },
                    300
                )
                .promise()
                .done(function () {
                    setTimeout(function () {
                        sidebarSections.scrollingToTarget = false;
                    }, 100);
                });
        },

        set: {
            selectedSection: function () {
                if (window.location.hash) {
                    sidebarSections.$block.find('a[href="' + window.location.hash + '"]').addClass('active');
                }
            },
        },

        get: {
            scrollingSectionPoints: function () {
                return sidebarSections.$scrollPoints;
            },

            htmlSection: function ($this) {
                return '<li><a href="#' + $this.attr('id') + '">' + $this.html() + '</a></li>';
            },

            fixedpageElementsHeight: function (currentScrollPos) {
                var elementsHeight = 0;

                if (sidebarSections.prevScrollpos > currentScrollPos) {
                    elementsHeight = $('header').outerHeight();
                }

                $('.sticky-element').each(function () {
                    if ($(this).outerHeight() > 0) {
                        elementsHeight += $(this).outerHeight();
                    }
                });
                return elementsHeight;
            },
        },
        check: {
            reachFooterEdge: function () {
                var docViewBottom = $(window).scrollTop() + $(window).height();
                var footerTopOffset = $('footer').offset().top - $('.actionsbar__has__sections').outerHeight();
                return footerTopOffset <= docViewBottom;
            },
        },
    };

    UX.sidebarSections = sidebarSections; // add to global namespace
})();
